import { Grid, TextField, Typography } from "@mui/material";

type PersonalDetailsProps = {
  form: any;
  allowEmailChange: boolean;
};

export const PersonalDetailsForm = ({
  form,
  allowEmailChange
}: PersonalDetailsProps) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">Employee details</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          value={form.values.firstName}
          onChange={form.handleChange}
          label="First name"
          name="firstName"
          required
          fullWidth
          size="small"
          error={form.touched.firstName && Boolean(form.errors.firstName)}
          helperText={form.touched.firstName && form.errors.firstName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          value={form.values.lastName}
          onChange={form.handleChange}
          label="Last name"
          name="lastName"
          required
          fullWidth
          size="small"
          error={form.touched.lastName && Boolean(form.errors.lastName)}
          helperText={form.touched.lastName && form.errors.lastName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          value={form.values.email}
          onChange={form.handleChange}
          label="Email"
          type="email"
          name="email"
          required
          fullWidth
          size="small"
          InputProps={{
            readOnly: !allowEmailChange
          }}
          error={form.touched.email && Boolean(form.errors.email)}
          helperText={form.touched.email && form.errors.email}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          value={form.values.phone}
          onChange={form.handleChange}
          label="Phone"
          name="phone"
          required
          fullWidth
          type="tel"
          size="small"
          error={form.touched.phone && Boolean(form.errors.phone)}
          helperText={form.touched.phone && form.errors.phone}
        />
      </Grid>
    </>
  );
};
